export function initFooter() {
    const footerAccordions = document.querySelectorAll('.c_footer-accordion');
    
    footerAccordions.forEach(accordion => {
        const trigger = accordion.querySelector('.c_footer-accordion-trigger');
        const content = accordion.querySelector('.c_footer-accordion-content');

        if (trigger && content) {
            trigger.addEventListener('click', function () {
                // Only work on mobile (below 768px)
                if (window.innerWidth >= 768) return;
                
                const isOpen = accordion.classList.contains('is-open');
                
                // Toggle the open state
                accordion.classList.toggle('is-open');
                
                // Toggle aria-expanded
                trigger.setAttribute('aria-expanded', !isOpen);
                
                // Slide toggle the content
                if (!isOpen) {
                    content.style.maxHeight = content.scrollHeight + 'px';
                } else {
                    content.style.maxHeight = '0';
                }
            });
        }
    });
    
    // Handle resize to reset accordion state on desktop
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            if (window.innerWidth >= 768) {
                footerAccordions.forEach(accordion => {
                    const trigger = accordion.querySelector('.c_footer-accordion-trigger');
                    const content = accordion.querySelector('.c_footer-accordion-content');
                    const icon = trigger?.querySelector('.c_footer-accordion-icon');
                    
                    if (content) {
                        content.style.maxHeight = '';
                    }
                    if (icon) {
                        icon.style.transform = '';
                    }
                    if (trigger) {
                        trigger.setAttribute('aria-expanded', 'false');
                    }
                    accordion.classList.remove('is-open');
                });
            }
        }, 250);
    });
}

